var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScanQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 214.51 244.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-4,.cls-6{fill:#fff;}.cls-2{stroke:#1d1d1b;stroke-miterlimit:10;}.cls-3{fill:#010101;}.cls-5{fill:#4593d0;}.cls-6{font-size:6.75px;font-family:Roboto-Bold, Roboto;font-weight:700;letter-spacing:0.2em;}.cls-7{fill:#1b1a38;}.cls-8{fill:#e52521;}.cls-9{fill:url(#linear-gradient);}.cls-10{fill:#fbcfb4;opacity:0.3;mix-blend-mode:screen;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3935.72,
    y1: 99.35,
    x2: 3935.72,
    y2: 74.91,
    gradientTransform: "matrix(1, 0, 0, -1, -3813.97, 183.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52521"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 21.03,
    width: 213.51,
    height: 222.67,
    rx: 5.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.67,46.58a1.61,1.61,0,0,1-1.61-1.6v1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.49,45V40.62A1.61,1.61,0,0,1,133.1,39h4.35a1.61,1.61,0,0,1,1.61,1.61h0v6h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.82,46.58a1.6,1.6,0,0,1-1.6-1.6v1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.65,45V40.62A1.61,1.61,0,0,1,95.25,39h4.36a1.61,1.61,0,0,1,1.61,1.61h0v6H93.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.51,
    y: 39.01,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.67,46.58H145a1.61,1.61,0,0,1,1.61,1.61h0v4.35A1.61,1.61,0,0,1,145,54.15h-6V46.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.49,
    y: 46.58,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.53,54.15a1.61,1.61,0,0,1-1.61-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.89,54.15a1.61,1.61,0,0,0,1.6-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.32,46.58a1.61,1.61,0,0,1,1.6,1.61h0v6h-7.57V46.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.79,
    y: 46.58,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.22,
    y: 46.58,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.65,52.54a1.61,1.61,0,0,0,1.6,1.61h6V46.58H93.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.06,55.76V54.15h1.61A1.61,1.61,0,0,0,139.06,55.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.67,61.72a1.61,1.61,0,0,1-1.61-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.49,
    y: 54.15,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.92,
    y: 54.15,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.35,
    y: 54.15,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,54.15h1.6v1.61a1.61,1.61,0,0,0-1.6-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.67,61.72H145a1.61,1.61,0,0,1,1.61,1.61h0v4.35A1.61,1.61,0,0,1,145,69.29h-6V61.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.49,67.68a1.61,1.61,0,0,0,1.61,1.61h6V61.72h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.89,61.72h1.6v1.61a1.61,1.61,0,0,0-1.6-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.92,63.33V61.72h1.61A1.61,1.61,0,0,0,123.92,63.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.92,67.68a1.61,1.61,0,0,1-1.6,1.61H118a1.61,1.61,0,0,1-1.61-1.61v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.22,
    y: 61.72,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92,61.72a1.61,1.61,0,0,1,1.61,1.61h0v6H86.08V61.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.12,61.72a1.61,1.61,0,0,0-1.61,1.61v6h7.57V61.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.92,75.25V70.9a1.61,1.61,0,0,1,1.61-1.61h4.36a1.61,1.61,0,0,1,1.6,1.61h0v6h-7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.79,
    y: 69.29,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.25,76.86a1.61,1.61,0,0,1-1.6-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.08,
    y: 69.29,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.51,75.25a1.61,1.61,0,0,0,1.61,1.61h6V69.29H78.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.06,82.82V78.47a1.61,1.61,0,0,1,1.61-1.61H145a1.61,1.61,0,0,1,1.61,1.61h0v6h-7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.92,
    y: 76.86,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.82,76.86h4.36a1.62,1.62,0,0,1,1.61,1.61h0v4.35a1.62,1.62,0,0,1-1.61,1.61h-6V76.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.65,
    y: 76.86,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.08,82.82a1.61,1.61,0,0,0,1.61,1.61h6V76.86H86.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.47,76.86h1.61v1.61a1.61,1.61,0,0,0-1.61-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.63,90.39A1.61,1.61,0,0,1,145,92h-4.35a1.61,1.61,0,0,1-1.61-1.61v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.49,90.39a1.61,1.61,0,0,1-1.6,1.61h-4.36a1.61,1.61,0,0,1-1.61-1.61v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.79,90.39V86a1.61,1.61,0,0,1,1.6-1.61h4.36a1.61,1.61,0,0,1,1.6,1.61h0v6h-7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.22,86V84.43h1.6A1.61,1.61,0,0,0,101.22,86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.22,90.39A1.61,1.61,0,0,1,99.61,92H95.25a1.61,1.61,0,0,1-1.6-1.61v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92,84.43h1.61V86A1.61,1.61,0,0,0,92,84.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.51,90.39V86a1.61,1.61,0,0,1,1.61-1.61h4.35A1.61,1.61,0,0,1,86.08,86h0v6H78.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.79,
    y: 92,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.18,99.57A1.62,1.62,0,0,0,108.79,98v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.08,98a1.61,1.61,0,0,1-1.61,1.61H80.12A1.61,1.61,0,0,1,78.51,98V92h7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.23,99.57h4.35a1.61,1.61,0,0,1,1.61,1.61h0v4.35a1.61,1.61,0,0,1-1.61,1.61h-6V99.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 192.05,
    y: 99.57,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 184.48,
    y: 99.57,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 176.91,
    y: 99.57,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.3,107.14H171a1.61,1.61,0,0,1-1.61-1.61v-4.35A1.61,1.61,0,0,1,171,99.57h6v7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.81,99.57h4.35a1.61,1.61,0,0,1,1.61,1.61h0v4.35a1.61,1.61,0,0,1-1.61,1.61h-6V99.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 146.63,
    y: 99.57,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.06,
    y: 99.57,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.49,
    y: 99.57,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.89,107.14h-4.36a1.61,1.61,0,0,1-1.61-1.61v-4.35a1.61,1.61,0,0,1,1.61-1.61h6v7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.35,105.53a1.61,1.61,0,0,1-1.6,1.61h-6V99.57h7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.18,107.14h-4.36a1.61,1.61,0,0,1-1.6-1.61v-4.35a1.61,1.61,0,0,1,1.6-1.61h6v7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.08,105.53v-4.35a1.61,1.61,0,0,1,1.61-1.61H92a1.61,1.61,0,0,1,1.61,1.61h0v6H86.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.73,104.38A1.78,1.78,0,0,1,75,102.6v1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.47,107.14a1.61,1.61,0,0,0,1.61-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.6,102.6V97.79A1.77,1.77,0,0,1,68.37,96h4.81A1.78,1.78,0,0,1,75,97.79h0v6.59H66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.88,102.6V97.79A1.77,1.77,0,0,1,51.66,96h4.8a1.78,1.78,0,0,1,1.78,1.77h0v6.59H49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.1,104.38a1.78,1.78,0,0,0,1.78-1.78v1.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.16,
    y: 96.02,
    width: 8.36,
    height: 8.36,
    rx: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.45,
    y: 96.02,
    width: 8.36,
    height: 8.36,
    rx: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.62,108.75v-1.61h1.61A1.61,1.61,0,0,0,199.62,108.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.62,113.1a1.61,1.61,0,0,1-1.61,1.61h-4.35a1.61,1.61,0,0,1-1.61-1.61v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.44,107.14h1.61v1.61a1.61,1.61,0,0,0-1.61-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.2,108.75v-1.61h1.61A1.61,1.61,0,0,0,154.2,108.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.2,113.1a1.61,1.61,0,0,1-1.61,1.61h-6v-7.57h7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.06,
    y: 107.14,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.49,
    y: 107.14,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.89,107.14h1.6v1.61a1.61,1.61,0,0,0-1.6-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.25,114.71a1.61,1.61,0,0,1-1.6-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.08,
    y: 107.14,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.51,
    y: 107.14,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.6,
    y: 104.38,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.82,112.74A1.78,1.78,0,0,0,66.6,111v1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.24,111a1.78,1.78,0,0,1-1.78,1.78H49.88v-8.36h8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.3,104.38a1.78,1.78,0,0,0-1.78,1.77v6.59h8.36v-8.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.09,
    y: 104.38,
    width: 8.36,
    height: 8.36,
    rx: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 199.62,
    y: 114.71,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.44,114.71a1.61,1.61,0,0,1,1.61,1.61h0v6h-7.57v-7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 176.91,
    y: 114.71,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.3,122.28H171a1.61,1.61,0,0,1-1.61-1.61v-4.35a1.61,1.61,0,0,1,1.61-1.61h6v7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 154.2,
    y: 114.71,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.63,116.32v-1.61h1.61A1.61,1.61,0,0,0,146.63,116.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.06,
    y: 114.71,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.49,
    y: 114.71,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.53,122.28a1.61,1.61,0,0,1-1.61-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.89,122.28a1.61,1.61,0,0,0,1.6-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.32,114.71a1.61,1.61,0,0,1,1.6,1.61h0v6h-7.57v-7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.79,
    y: 114.71,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.22,
    y: 114.71,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.65,
    y: 114.71,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.08,120.67a1.61,1.61,0,0,0,1.61,1.61h6v-7.57H86.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.47,114.71h1.61v1.61a1.61,1.61,0,0,0-1.61-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75,114.51v-1.77h1.77A1.77,1.77,0,0,0,75,114.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.73,121.09A1.77,1.77,0,0,1,75,119.32v1.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.6,
    y: 112.74,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.82,121.09H60a1.77,1.77,0,0,1-1.77-1.77v-4.81A1.77,1.77,0,0,1,60,112.74H66.6v8.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.88,114.51v-1.77h1.78A1.77,1.77,0,0,0,49.88,114.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.88,119.32a1.78,1.78,0,0,1-1.78,1.77H43.3a1.78,1.78,0,0,1-1.78-1.77v-6.58h8.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.8,
    y: 112.74,
    width: 8.36,
    height: 8.36,
    rx: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 184.48,
    y: 122.28,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.87,122.28h1.61v1.61a1.61,1.61,0,0,0-1.61-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.63,128.24a1.61,1.61,0,0,1-1.61,1.61h-6v-7.57h7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.49,
    y: 122.28,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.92,
    y: 122.28,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.35,
    y: 122.28,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,122.28h1.6v1.61a1.61,1.61,0,0,0-1.6-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.12,122.28h4.35a1.61,1.61,0,0,1,1.61,1.61h0v4.35a1.61,1.61,0,0,1-1.61,1.61h-6v-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.6,127.68a1.77,1.77,0,0,0,1.77,1.77H75v-8.36H66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.82,121.09H66.6v1.78a1.78,1.78,0,0,0-1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.05,135.81a1.61,1.61,0,0,1-1.61,1.61h-4.35a1.61,1.61,0,0,1-1.61-1.61v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 154.2,
    y: 129.85,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.06,131.46v-1.61h1.61A1.61,1.61,0,0,0,139.06,131.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.06,135.81a1.61,1.61,0,0,1-1.61,1.61H133.1a1.61,1.61,0,0,1-1.61-1.61v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.89,129.85h1.6v1.61a1.61,1.61,0,0,0-1.6-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.92,131.46v-1.61h1.61A1.61,1.61,0,0,0,123.92,131.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.92,135.81a1.61,1.61,0,0,1-1.6,1.61H118a1.61,1.61,0,0,1-1.61-1.61v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.22,
    y: 129.85,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.08,
    y: 129.85,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.37,137.81A1.77,1.77,0,0,1,66.6,136v1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.82,129.45a1.78,1.78,0,0,1,1.78,1.78h0v6.58H58.24v-8.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 49.88,
    y: 129.45,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 129.45,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.74,137.81h-4.8A1.78,1.78,0,0,1,33.16,136v-4.81a1.78,1.78,0,0,1,1.78-1.78h6.58v8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.22,129.45H23a1.78,1.78,0,0,1,1.77,1.78h0V136A1.77,1.77,0,0,1,23,137.81H16.45v-8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.67,137.81H9.86A1.77,1.77,0,0,1,8.09,136v-4.81a1.78,1.78,0,0,1,1.77-1.78h6.59v8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.62,143.38V139a1.61,1.61,0,0,1,1.61-1.61h4.35a1.61,1.61,0,0,1,1.61,1.61h0v6h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M186.09,145a1.61,1.61,0,0,1-1.61-1.61V145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.91,143.38V139a1.61,1.61,0,0,1,1.61-1.61h4.35a1.61,1.61,0,0,1,1.61,1.61h0v6h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.3,145a1.61,1.61,0,0,0,1.61-1.61V145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.81,145a1.61,1.61,0,0,1-1.61-1.61V145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.63,143.38V139a1.61,1.61,0,0,1,1.61-1.61h4.35A1.61,1.61,0,0,1,154.2,139h0v6h-7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.92,
    y: 137.42,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.79,
    y: 137.42,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.82,145a1.61,1.61,0,0,1-1.6-1.61V145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.65,143.38V139a1.61,1.61,0,0,1,1.6-1.61h4.36a1.61,1.61,0,0,1,1.61,1.61h0v6H93.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.12,137.42h4.35A1.61,1.61,0,0,1,86.08,139h0v4.35A1.61,1.61,0,0,1,84.47,145h-6v-7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.6,
    y: 137.81,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.24,
    y: 137.81,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 49.88,
    y: 137.81,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 137.81,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.74,137.81h1.78v1.78a1.78,1.78,0,0,0-1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 199.62,
    y: 144.99,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.44,145a1.61,1.61,0,0,1,1.61,1.61h0v6h-7.57V145Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 176.91,
    y: 144.99,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 169.34,
    y: 144.99,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 161.77,
    y: 144.99,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 154.2,
    y: 144.99,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 146.63,
    y: 144.99,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.67,152.56a1.61,1.61,0,0,1-1.61-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145,152.56a1.61,1.61,0,0,0,1.61-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.49,151V146.6A1.61,1.61,0,0,1,133.1,145h4.35a1.61,1.61,0,0,1,1.61,1.61h0v6h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.82,145h4.36a1.62,1.62,0,0,1,1.61,1.61h0V151a1.62,1.62,0,0,1-1.61,1.61h-6V145Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.65,
    y: 144.99,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75,148v-1.78h1.77A1.78,1.78,0,0,0,75,148Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.6,
    y: 146.17,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.24,152.75A1.78,1.78,0,0,0,60,154.53H66.6v-8.36H58.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.46,146.17h1.78V148a1.78,1.78,0,0,0-1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.88,148v-1.78h1.78A1.78,1.78,0,0,0,49.88,148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.88,152.75a1.78,1.78,0,0,1-1.78,1.78H43.3a1.78,1.78,0,0,1-1.78-1.78v-6.58h8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.58,146.17h4.81A1.78,1.78,0,0,1,33.16,148h0v4.8a1.78,1.78,0,0,1-1.77,1.78H24.8v-8.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.45,
    y: 146.17,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.86,146.17A1.78,1.78,0,0,0,8.09,148v6.58h8.36v-8.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 199.62,
    y: 152.56,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.05,158.52a1.61,1.61,0,0,1-1.61,1.61h-4.35a1.61,1.61,0,0,1-1.61-1.61v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.87,152.56h1.61v1.6a1.61,1.61,0,0,0-1.61-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.2,154.16v-1.6h1.61A1.61,1.61,0,0,0,154.2,154.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.81,160.13a1.61,1.61,0,0,1-1.61-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 146.63,
    y: 152.56,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.06,
    y: 152.56,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.49,
    y: 152.56,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.89,160.13a1.61,1.61,0,0,0,1.6-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.79,158.52v-4.36a1.6,1.6,0,0,1,1.6-1.6h4.36a1.6,1.6,0,0,1,1.6,1.6h0v6h-7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.22,154.16v-1.6h1.6A1.6,1.6,0,0,0,101.22,154.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.65,
    y: 152.56,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92,160.13a1.61,1.61,0,0,0,1.61-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.73,162.89A1.78,1.78,0,0,1,75,161.11v1.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.6,
    y: 154.53,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.82,154.53H66.6v1.78a1.78,1.78,0,0,0-1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.82,162.89a1.78,1.78,0,0,0,1.78-1.78v1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.8,156.31v-1.78h1.78A1.78,1.78,0,0,0,24.8,156.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.8,161.11A1.78,1.78,0,0,1,23,162.89H16.45v-8.36H24.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.09,
    y: 154.53,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.19,166.09a1.61,1.61,0,0,1-1.61,1.6h-4.35a1.61,1.61,0,0,1-1.61-1.6v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 169.34,
    y: 160.13,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.81,160.13h4.35a1.61,1.61,0,0,1,1.61,1.6h0v4.36a1.61,1.61,0,0,1-1.61,1.6h-6v-7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.63,166.09a1.61,1.61,0,0,0,1.61,1.6h6v-7.56h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145,160.13h1.61v1.6a1.61,1.61,0,0,0-1.61-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.06,161.73v-1.6h1.61A1.61,1.61,0,0,0,139.06,161.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.67,167.69a1.61,1.61,0,0,1-1.61-1.6v1.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.49,
    y: 160.13,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.89,167.69h-4.36a1.61,1.61,0,0,1-1.61-1.6v-4.36a1.61,1.61,0,0,1,1.61-1.6h6v7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.35,166.09a1.6,1.6,0,0,1-1.6,1.6h-4.36a1.6,1.6,0,0,1-1.6-1.6v-6h7.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.65,
    y: 160.13,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.08,
    y: 160.13,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.51,
    y: 160.13,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.6,
    y: 162.89,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.24,
    y: 162.89,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 49.88,
    y: 162.89,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 162.89,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.74,171.25h-4.8a1.78,1.78,0,0,1-1.78-1.78v-4.81a1.78,1.78,0,0,1,1.78-1.77h6.58v8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.45,164.66v-1.77h1.77A1.77,1.77,0,0,0,16.45,164.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.09,
    y: 162.89,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145,167.69a1.62,1.62,0,0,1,1.61,1.61h0v6h-7.57v-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.49,173.66a1.61,1.61,0,0,0,1.61,1.6h6v-7.57h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.89,167.69h1.6v1.61a1.61,1.61,0,0,0-1.6-1.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.65,
    y: 167.69,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92,167.69h1.61v1.61A1.62,1.62,0,0,0,92,167.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.08,169.3v-1.61h1.61A1.62,1.62,0,0,0,86.08,169.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.51,
    y: 167.69,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.18,171.25H75V173a1.78,1.78,0,0,0-1.78-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.88,173v-1.77h1.78A1.77,1.77,0,0,0,49.88,173Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 171.25,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.74,171.25h1.78V173a1.77,1.77,0,0,0-1.78-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.22,179.61a1.78,1.78,0,0,1-1.77-1.78v1.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.09,
    y: 171.25,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.63,181.23a1.61,1.61,0,0,1-1.61,1.6h-4.35a1.61,1.61,0,0,1-1.61-1.6v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.45,175.26h1.61v1.61a1.61,1.61,0,0,0-1.61-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.32,175.26a1.61,1.61,0,0,1,1.6,1.61h0v6h-7.57v-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,182.83h-4.36a1.6,1.6,0,0,1-1.6-1.6v-4.36a1.61,1.61,0,0,1,1.6-1.61h6v7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.22,181.23a1.61,1.61,0,0,1-1.61,1.6H95.25a1.6,1.6,0,0,1-1.6-1.6v-6h7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.51,
    y: 175.26,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.24,
    y: 179.61,
    width: 8.36,
    height: 8.36,
    rx: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 179.61,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.74,188a1.77,1.77,0,0,0,1.78-1.77V188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.58,179.61h4.81a1.77,1.77,0,0,1,1.77,1.77h0v4.81A1.77,1.77,0,0,1,31.39,188H24.8v-8.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.45,
    y: 179.61,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.09,186.19A1.77,1.77,0,0,0,9.86,188h6.59v-8.35H8.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.49,
    y: 182.83,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.53,190.4a1.61,1.61,0,0,1-1.61-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.35,
    y: 182.83,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,182.83h1.6v1.61a1.61,1.61,0,0,0-1.6-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,190.4a1.61,1.61,0,0,0,1.6-1.61v1.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.22,
    y: 182.83,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.51,
    y: 182.83,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.18,196.32A1.78,1.78,0,0,0,75,194.55v1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.66,196.32a1.77,1.77,0,0,1-1.78-1.77v1.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 187.96,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.94,188a1.78,1.78,0,0,0-1.78,1.78v6.58h8.36V188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.06,196.36V192a1.61,1.61,0,0,1,1.61-1.61H145a1.61,1.61,0,0,1,1.61,1.61h0v6h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.53,190.4h4.36a1.61,1.61,0,0,1,1.6,1.61h0v4.35a1.61,1.61,0,0,1-1.6,1.61h-6V190.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.35,
    y: 190.4,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.39,190.4a1.61,1.61,0,0,0-1.6,1.61v6h7.56V190.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.65,
    y: 190.4,
    width: 7.57,
    height: 7.57,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.09,204.68a1.78,1.78,0,0,1-1.78-1.78v1.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.51,
    y: 190.4,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.6,
    y: 196.32,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.24,
    y: 196.32,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 49.88,
    y: 196.32,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 196.32,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.16,202.9a1.78,1.78,0,0,0,1.78,1.78h6.58v-8.36H33.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 141.83,
    y: 204.68,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.05,213a1.78,1.78,0,0,0,1.78-1.78V213Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.75,206.46v-1.78h1.78A1.78,1.78,0,0,0,116.75,206.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.39,
    y: 204.68,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.09,204.68H89.9a1.78,1.78,0,0,1,1.77,1.78h0v4.8A1.78,1.78,0,0,1,89.9,213H83.31v-8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75,211.26A1.78,1.78,0,0,0,76.73,213h6.58v-8.36H75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.18,204.68H75v1.78a1.78,1.78,0,0,0-1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.6,206.46v-1.78h1.77A1.78,1.78,0,0,0,66.6,206.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.6,211.26A1.78,1.78,0,0,1,64.82,213H60a1.78,1.78,0,0,1-1.77-1.78v-6.58H66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.46,204.68h1.78v1.78a1.78,1.78,0,0,0-1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.88,206.46v-1.78h1.78A1.78,1.78,0,0,0,49.88,206.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 204.68,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.74,204.68h1.78v1.78a1.78,1.78,0,0,0-1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.22,204.68H23a1.78,1.78,0,0,1,1.77,1.78h0v4.8A1.78,1.78,0,0,1,23,213H16.45v-8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.86,204.68a1.78,1.78,0,0,0-1.77,1.78V213h8.36v-8.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 141.83,
    y: 213.04,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 133.47,
    y: 213.04,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.69,221.4h-4.81a1.78,1.78,0,0,1-1.77-1.78v-4.8a1.77,1.77,0,0,1,1.77-1.78h6.59v8.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.39,
    y: 213.04,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.81,221.4a1.78,1.78,0,0,1-1.78-1.78v1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.61,221.4a1.78,1.78,0,0,0,1.78-1.78v1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.67,219.62v-4.8A1.78,1.78,0,0,1,93.45,213h4.81a1.77,1.77,0,0,1,1.77,1.78h0v6.58H91.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.66,221.4a1.78,1.78,0,0,1-1.78-1.78v1.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 213.04,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.74,221.4a1.78,1.78,0,0,0,1.78-1.78v1.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.8,
    y: 213.04,
    width: 8.36,
    height: 8.36,
    rx: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.45,214.82V213h1.77A1.77,1.77,0,0,0,16.45,214.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.45,219.62a1.78,1.78,0,0,1-1.78,1.78H9.86a1.78,1.78,0,0,1-1.77-1.78V213h8.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 141.83,
    y: 221.4,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.05,221.4h1.78v1.77a1.78,1.78,0,0,0-1.78-1.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.39,
    y: 221.4,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.03,
    y: 221.4,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.67,228a1.78,1.78,0,0,0,1.78,1.78H100V221.4H91.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.73,221.4h4.81a1.77,1.77,0,0,1,1.77,1.77h0V228a1.78,1.78,0,0,1-1.77,1.78H75V221.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.6,
    y: 221.4,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.24,
    y: 221.4,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 49.88,
    y: 221.4,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.52,
    y: 221.4,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.74,229.76h-4.8A1.78,1.78,0,0,1,33.16,228v-4.81a1.78,1.78,0,0,1,1.78-1.77h6.58v8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.58,229.76A1.78,1.78,0,0,1,24.8,228v1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.45,228v-4.81a1.77,1.77,0,0,1,1.77-1.77H23a1.77,1.77,0,0,1,1.77,1.77h0v6.59H16.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.67,229.76A1.78,1.78,0,0,0,16.45,228v1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.18,236.34a1.78,1.78,0,0,1-1.77,1.78H143.6a1.78,1.78,0,0,1-1.77-1.78v-6.58h8.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.11,
    y: 229.76,
    width: 8.36,
    height: 8.36,
    rx: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.75,236.34a1.78,1.78,0,0,1-1.78,1.78h-6.58v-8.36h8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100,236.34a1.78,1.78,0,0,0,1.78,1.78h6.58v-8.36H100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.26,229.76H100v1.77a1.77,1.77,0,0,0-1.77-1.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.31,
    y: 229.76,
    width: 8.36,
    height: 8.36,
    rx: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.58,229.76h4.81a1.77,1.77,0,0,1,1.77,1.77h0v4.81a1.78,1.78,0,0,1-1.77,1.78H24.8v-8.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.45,
    y: 229.76,
    width: 8.36,
    height: 8.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.67,238.12H9.86a1.78,1.78,0,0,1-1.77-1.78v-4.81a1.77,1.77,0,0,1,1.77-1.77h6.59v8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.81,39a1.61,1.61,0,0,0-1.62,1.61V90.4A1.62,1.62,0,0,0,155.81,92h49.77a1.62,1.62,0,0,0,1.62-1.61V40.62A1.62,1.62,0,0,0,205.58,39Zm6,8.5a.93.93,0,0,1,.92-.93h36a.93.93,0,0,1,.92.93v36a.92.92,0,0,1-.92.92h-36a.92.92,0,0,1-.92-.92v-36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.34,69.29V55.76A1.61,1.61,0,0,1,171,54.15h19.49a1.61,1.61,0,0,1,1.62,1.61v19.5a1.62,1.62,0,0,1-1.62,1.61H171a1.62,1.62,0,0,1-1.61-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.86,29.14a1.78,1.78,0,0,0-1.78,1.78v55a1.78,1.78,0,0,0,1.78,1.78h55a1.78,1.78,0,0,0,1.78-1.78v-55a1.79,1.79,0,0,0-1.78-1.78Zm6.59,9.39a1,1,0,0,1,1-1H57.22a1,1,0,0,1,1,1V78.28a1,1,0,0,1-1,1H17.46a1,1,0,0,1-1-1V38.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.8,62.58V47.64a1.78,1.78,0,0,1,1.78-1.78H48.11a1.78,1.78,0,0,1,1.78,1.78V69.17A1.78,1.78,0,0,1,48.11,71H26.58a1.78,1.78,0,0,1-1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.81,175.26a1.61,1.61,0,0,0-1.62,1.61v49.78a1.62,1.62,0,0,0,1.62,1.61h49.77a1.62,1.62,0,0,0,1.62-1.61V176.87a1.62,1.62,0,0,0-1.62-1.61Zm6,8.5a.93.93,0,0,1,.92-.93h36a.93.93,0,0,1,.92.93v36a.92.92,0,0,1-.92.92h-36a.92.92,0,0,1-.92-.92v-36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.34,205.54V192A1.61,1.61,0,0,1,171,190.4h19.49a1.61,1.61,0,0,1,1.62,1.61v19.5a1.62,1.62,0,0,1-1.62,1.61H171a1.62,1.62,0,0,1-1.61-1.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 75.93,
    y: 3.19,
    width: 92.62,
    height: 192.11,
    rx: 11.98,
    transform: "translate(244.47 198.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.13,55.59a.72.72,0,0,0,.72-.72V43.78a.72.72,0,0,0-.72-.72H147.77a.72.72,0,0,0,0,1.44h10.64V54.87A.73.73,0,0,0,159.13,55.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.77,118h11.36a.72.72,0,0,0,.72-.72v-11a.72.72,0,0,0-1.44,0v10.32H147.77a.72.72,0,0,0,0,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.64,55.59a.72.72,0,0,0,.72-.72V44.5H96.49a.72.72,0,0,0,0-1.44H85.64a.72.72,0,0,0-.72.72V54.87A.72.72,0,0,0,85.64,55.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.64,118H96.49a.72.72,0,0,0,0-1.44H86.36V106.24a.72.72,0,0,0-1.44,0v11A.72.72,0,0,0,85.64,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143,156.7H101.81a8.09,8.09,0,0,1-8.09-8.09h0a8.1,8.1,0,0,1,8.09-8.09H143a8.09,8.09,0,0,1,8.09,8.09h0A8.09,8.09,0,0,1,143,156.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.28,
    y: 46.42,
    width: 68.22,
    height: 68.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.49,55.43A.47.47,0,0,1,130,55v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.85,55V53.71a.46.46,0,0,1,.46-.47h1.25a.47.47,0,0,1,.47.47h0v1.72h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.58,55.43a.47.47,0,0,1-.47-.47v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.93,55V53.71a.47.47,0,0,1,.46-.47h1.26a.47.47,0,0,1,.46.47h0v1.72h-2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.56,
    y: 53.24,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.49,55.43h1.26a.47.47,0,0,1,.46.46h0v1.26a.47.47,0,0,1-.46.46H130V55.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 55.43,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.13,57.61a.47.47,0,0,1-.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,57.61a.47.47,0,0,0,.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.2,55.43a.47.47,0,0,1,.46.46h0v1.72h-2.18V55.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.3,
    y: 55.43,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.11,
    y: 55.43,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.93,57.15a.47.47,0,0,0,.46.46h1.72V55.43h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130,58.07v-.46h.46A.47.47,0,0,0,130,58.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.49,59.79a.46.46,0,0,1-.46-.46v.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 57.61,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.66,
    y: 57.61,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.48,
    y: 57.61,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123,57.61h.47v.46a.47.47,0,0,0-.47-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.49,59.79h1.26a.47.47,0,0,1,.46.47h0v1.25a.47.47,0,0,1-.46.47H130V59.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.85,61.51a.46.46,0,0,0,.46.47H130V59.79h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,59.79h.47v.47a.47.47,0,0,0-.47-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.66,60.26v-.47h.47A.47.47,0,0,0,125.66,60.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.66,61.51a.47.47,0,0,1-.46.47h-1.26a.47.47,0,0,1-.46-.47V59.79h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.11,
    y: 59.79,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.47,59.79a.47.47,0,0,1,.46.47h0V62h-2.18V59.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113,59.79a.47.47,0,0,0-.47.47V62h2.19V59.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.66,63.7V62.44a.47.47,0,0,1,.47-.46h1.25a.47.47,0,0,1,.47.46h0v1.72h-2.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.3,
    y: 61.98,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.39,64.16a.47.47,0,0,1-.46-.46v.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.75,
    y: 61.98,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.56,63.7a.47.47,0,0,0,.47.46h1.72V62h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130,65.88V64.62a.47.47,0,0,1,.46-.46h1.26a.47.47,0,0,1,.46.46h0v1.72H130Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.66,
    y: 64.16,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.58,64.16h1.25a.47.47,0,0,1,.47.46h0v1.26a.46.46,0,0,1-.47.46h-1.72V64.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.93,
    y: 64.16,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,65.88a.45.45,0,0,0,.46.46h1.72V64.16h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.28,64.16h.47v.46a.47.47,0,0,0-.47-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.21,68.06a.47.47,0,0,1-.46.47h-1.26a.47.47,0,0,1-.46-.47V66.34h2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.85,68.06a.47.47,0,0,1-.47.47h-1.25a.47.47,0,0,1-.47-.47V66.34h2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.3,68.06V66.81a.46.46,0,0,1,.46-.47H123a.47.47,0,0,1,.47.47h0v1.72H121.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.11,66.81v-.47h.47A.47.47,0,0,0,119.11,66.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.11,68.06a.47.47,0,0,1-.46.47h-1.26a.47.47,0,0,1-.46-.47V66.34h2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.47,66.34h.46v.47a.47.47,0,0,0-.46-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.56,68.06V66.81a.47.47,0,0,1,.47-.47h1.25a.47.47,0,0,1,.47.47h0v1.72h-2.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.3,
    y: 68.53,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.83,70.71a.47.47,0,0,0,.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,70.25a.47.47,0,0,1-.47.46H113a.47.47,0,0,1-.47-.46V68.53h2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148,70.71h1.25a.47.47,0,0,1,.47.46h0v1.26a.46.46,0,0,1-.47.46h-1.72V70.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 145.31,
    y: 70.71,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 143.13,
    y: 70.71,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.94,
    y: 70.71,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.48,72.89h-1.26a.46.46,0,0,1-.46-.46V71.17a.47.47,0,0,1,.46-.46h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.86,70.71h1.25a.47.47,0,0,1,.47.46h0v1.26a.46.46,0,0,1-.47.46h-1.72V70.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 132.21,
    y: 70.71,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.03,
    y: 70.71,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 70.71,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,72.89h-1.25a.46.46,0,0,1-.47-.46V71.17a.47.47,0,0,1,.47-.46h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.48,72.43a.46.46,0,0,1-.47.46H121.3V70.71h2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.83,72.89h-1.25a.46.46,0,0,1-.47-.46V71.17a.47.47,0,0,1,.47-.46h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,72.43V71.17a.46.46,0,0,1,.46-.46h1.26a.47.47,0,0,1,.46.46h0v1.72h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113,72.89a.46.46,0,0,1-.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.28,72.89a.46.46,0,0,0,.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.38,72.43V71.17a.47.47,0,0,1,.46-.46h1.26a.46.46,0,0,1,.46.46h0v1.72h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,72.43V71.17a.47.47,0,0,1,.47-.46h1.25a.47.47,0,0,1,.47.46h0v1.72H106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.55,72.89a.45.45,0,0,0,.46-.46v.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.65,
    y: 70.71,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 97.28,
    y: 70.71,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.49,73.36v-.47H148A.47.47,0,0,0,147.49,73.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.49,74.61a.46.46,0,0,1-.46.47h-1.26a.47.47,0,0,1-.46-.47V72.89h2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.85,72.89h.46v.47a.47.47,0,0,0-.46-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.39,73.36v-.47h.47A.47.47,0,0,0,134.39,73.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.39,74.61a.46.46,0,0,1-.46.47h-1.72V72.89h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.03,
    y: 72.89,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 72.89,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,72.89h.47v.47a.47.47,0,0,0-.47-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.39,75.08a.47.47,0,0,1-.46-.47v.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.75,
    y: 72.89,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.56,
    y: 72.89,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.38,
    y: 72.89,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.92,75.08a.47.47,0,0,0,.46-.47v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.2,74.61a.47.47,0,0,1-.47.47H106V72.89h2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.29,72.89a.47.47,0,0,0-.46.47v1.72H106V72.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 95.1,
    y: 72.89,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.49,
    y: 75.08,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.85,75.08a.46.46,0,0,1,.46.46h0v1.72h-2.18V75.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.94,
    y: 75.08,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.48,77.26h-1.26a.47.47,0,0,1-.46-.46V75.54a.46.46,0,0,1,.46-.46h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 134.39,
    y: 75.08,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.21,75.54v-.46h.47A.46.46,0,0,0,132.21,75.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.03,
    y: 75.08,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 75.08,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.13,77.26a.47.47,0,0,1-.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,77.26a.47.47,0,0,0,.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.2,75.08a.46.46,0,0,1,.46.46h0v1.72h-2.18V75.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.3,
    y: 75.08,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.11,
    y: 75.08,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.93,
    y: 75.08,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,76.8a.46.46,0,0,0,.46.46h1.72V75.08h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.28,75.08h.47v.46a.46.46,0,0,0-.47-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.56,75.54v-.46H113A.46.46,0,0,0,112.56,75.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113,77.26a.47.47,0,0,1-.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.38,
    y: 75.08,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.92,77.26h-1.26a.46.46,0,0,1-.46-.46V75.54a.45.45,0,0,1,.46-.46h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,75.54v-.46h.47A.46.46,0,0,0,106,75.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,76.8a.46.46,0,0,1-.46.46h-1.26a.47.47,0,0,1-.46-.46V75.08H106Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 99.46,
    y: 75.08,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 143.13,
    y: 77.26,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.66,77.26h.47v.46a.47.47,0,0,0-.47-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.21,79a.46.46,0,0,1-.46.46H130V77.26h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 77.26,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.66,
    y: 77.26,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.48,
    y: 77.26,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123,77.26h.47v.46a.47.47,0,0,0-.47-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113,77.26h1.25a.47.47,0,0,1,.47.46h0V79a.46.46,0,0,1-.47.46h-1.72V77.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.38,79a.46.46,0,0,0,.46.46h1.72V77.26h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.92,77.26h.46v.46a.47.47,0,0,0-.46-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.31,81.16a.47.47,0,0,1-.46.47h-1.26a.46.46,0,0,1-.46-.47V79.44h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 134.39,
    y: 79.44,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130,79.91v-.47h.46A.47.47,0,0,0,130,79.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130,81.16a.47.47,0,0,1-.47.47h-1.25a.46.46,0,0,1-.46-.47V79.44H130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,79.44h.47v.47a.47.47,0,0,0-.47-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.66,79.91v-.47h.47A.47.47,0,0,0,125.66,79.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.66,81.16a.47.47,0,0,1-.46.47h-1.26a.47.47,0,0,1-.46-.47V79.44h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.11,
    y: 79.44,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.75,
    y: 79.44,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.84,81.63a.47.47,0,0,1-.46-.47v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.92,79.44a.47.47,0,0,1,.46.47h0v1.72H108.2V79.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.01,
    y: 79.44,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 79.44,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.37,81.63h-1.26a.46.46,0,0,1-.46-.47V79.91a.46.46,0,0,1,.46-.47h1.72v2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.74,79.44H99a.46.46,0,0,1,.46.47h0v1.25a.46.46,0,0,1-.46.47H97.28V79.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.82,81.63H95.56a.47.47,0,0,1-.46-.47V79.91a.47.47,0,0,1,.46-.47h1.72v2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.49,83.35V82.09a.46.46,0,0,1,.47-.46h1.25a.46.46,0,0,1,.47.46h0v1.72h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.59,83.81a.46.46,0,0,1-.46-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.94,83.35V82.09a.46.46,0,0,1,.47-.46h1.25a.46.46,0,0,1,.47.46h0v1.72h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.48,83.81a.46.46,0,0,0,.46-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.86,83.81a.47.47,0,0,1-.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.21,83.35V82.09a.46.46,0,0,1,.47-.46h1.25a.45.45,0,0,1,.46.46h0v1.72h-2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.66,
    y: 81.63,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.3,
    y: 81.63,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.58,83.81a.47.47,0,0,1-.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.93,83.35V82.09a.46.46,0,0,1,.46-.46h1.26a.46.46,0,0,1,.46.46h0v1.72h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113,81.63h1.25a.46.46,0,0,1,.47.46h0v1.26a.47.47,0,0,1-.47.46h-1.72V81.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.38,
    y: 81.63,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.2,
    y: 81.63,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.01,
    y: 81.63,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 81.63,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.37,81.63h.46v.46a.46.46,0,0,0-.46-.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.49,
    y: 83.81,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.85,83.81a.47.47,0,0,1,.46.46h0V86h-2.18V83.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.94,
    y: 83.81,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 138.76,
    y: 83.81,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 136.58,
    y: 83.81,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 134.39,
    y: 83.81,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 132.21,
    y: 83.81,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.49,86a.47.47,0,0,1-.46-.46V86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.75,86a.47.47,0,0,0,.46-.46V86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.85,85.53V84.27a.46.46,0,0,1,.46-.46h1.25a.47.47,0,0,1,.47.46h0V86h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.58,83.81h1.25a.47.47,0,0,1,.47.46h0v1.26a.47.47,0,0,1-.47.46h-1.72V83.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.93,
    y: 83.81,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.56,84.27v-.46H113A.47.47,0,0,0,112.56,84.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.38,
    y: 83.81,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.2,85.53a.46.46,0,0,0,.46.46h1.72V83.81H108.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.73,83.81h.47v.46a.47.47,0,0,0-.47-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,84.27v-.46h.47A.47.47,0,0,0,106,84.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,85.53a.46.46,0,0,1-.46.46h-1.26a.47.47,0,0,1-.46-.46V83.81H106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.93,83.81h1.25a.47.47,0,0,1,.47.46h0v1.26a.47.47,0,0,1-.47.46H99.46V83.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 97.28,
    y: 83.81,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.56,83.81a.47.47,0,0,0-.46.46V86h2.18V83.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.49,
    y: 85.99,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.31,87.71a.47.47,0,0,1-.46.47h-1.26a.46.46,0,0,1-.46-.47V86h2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.66,86h.47v.47a.47.47,0,0,0-.47-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.39,86.46V86h.47A.47.47,0,0,0,134.39,86.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.86,88.18a.47.47,0,0,1-.47-.47v.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 132.21,
    y: 85.99,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.03,
    y: 85.99,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 85.99,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,88.18a.47.47,0,0,0,.47-.47v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.3,87.71V86.46a.46.46,0,0,1,.46-.47H123a.47.47,0,0,1,.47.47h0v1.72H121.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.11,86.46V86h.47A.47.47,0,0,0,119.11,86.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.93,
    y: 85.99,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.47,88.18a.47.47,0,0,0,.46-.47v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113,88.18a.47.47,0,0,1-.47-.47v.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.38,
    y: 85.99,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.92,86h.46v.47a.47.47,0,0,0-.46-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.92,88.18a.47.47,0,0,0,.46-.47v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.46,86.46V86h.47A.47.47,0,0,0,99.46,86.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.46,87.71a.46.46,0,0,1-.46.47H97.28V86h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 95.1,
    y: 85.99,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.68,89.89a.47.47,0,0,1-.47.47H148a.47.47,0,0,1-.47-.47V88.18h2.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 138.76,
    y: 88.18,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.86,88.18h1.25a.46.46,0,0,1,.47.46h0v1.25a.47.47,0,0,1-.47.47h-1.72V88.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.21,89.89a.47.47,0,0,0,.47.47h1.71V88.18h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.75,88.18h.46v.46a.46.46,0,0,0-.46-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130,88.64v-.46h.46A.46.46,0,0,0,130,88.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.49,90.36a.47.47,0,0,1-.46-.47v.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 88.18,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,90.36h-1.25a.47.47,0,0,1-.47-.47V88.64a.46.46,0,0,1,.47-.46h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.48,89.89a.47.47,0,0,1-.47.47h-1.25a.46.46,0,0,1-.46-.47V88.18h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.93,
    y: 88.18,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.75,
    y: 88.18,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.56,
    y: 88.18,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.38,
    y: 88.18,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.2,
    y: 88.18,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.01,
    y: 88.18,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 88.18,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.37,90.36h-1.26a.46.46,0,0,1-.46-.47V88.64a.45.45,0,0,1,.46-.46h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.28,88.64v-.46h.46A.46.46,0,0,0,97.28,88.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 95.1,
    y: 88.18,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.75,90.36a.47.47,0,0,1,.46.46h0v1.72H130V90.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.85,92.08a.46.46,0,0,0,.46.46H130V90.36h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,90.36h.47v.46a.47.47,0,0,0-.47-.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.93,
    y: 90.36,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.47,90.36h.46v.46a.47.47,0,0,0-.46-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.75,90.82v-.46h.46A.46.46,0,0,0,114.75,90.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.56,
    y: 90.36,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.1,90.36h.46v.46a.46.46,0,0,0-.46-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,90.82v-.46h.47A.47.47,0,0,0,106,90.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 90.36,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.37,90.36h.46v.46a.47.47,0,0,0-.46-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.74,92.54a.47.47,0,0,1-.46-.46v.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 95.1,
    y: 90.36,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.21,94.26a.46.46,0,0,1-.46.46h-1.26a.46.46,0,0,1-.46-.46V92.54h2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.56,92.54H130V93a.47.47,0,0,0-.47-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.2,92.54a.47.47,0,0,1,.46.47h0v1.71h-2.18V92.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123,94.72h-1.25a.45.45,0,0,1-.46-.46V93a.46.46,0,0,1,.46-.47h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.11,94.26a.46.46,0,0,1-.46.46h-1.26a.46.46,0,0,1-.46-.46V92.54h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.56,
    y: 92.54,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.2,
    y: 92.54,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 92.54,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.37,94.72a.46.46,0,0,0,.46-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.93,92.54h1.25a.47.47,0,0,1,.47.47h0v1.25a.46.46,0,0,1-.47.46H99.46V92.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 97.28,
    y: 92.54,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.1,94.26a.46.46,0,0,0,.46.46h1.72V92.54H95.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 94.72,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.13,96.91a.47.47,0,0,1-.47-.47v.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.48,
    y: 94.72,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123,94.72h.47v.47a.47.47,0,0,0-.47-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123,96.91a.47.47,0,0,0,.47-.47v.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.11,
    y: 94.72,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.56,
    y: 94.72,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.1,96.91a.46.46,0,0,0,.46-.47v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.48,96.91a.47.47,0,0,1-.47-.47v.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 94.72,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.11,94.72a.46.46,0,0,0-.46.47v1.72h2.18V94.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130,98.63V97.37a.47.47,0,0,1,.46-.46h1.26a.47.47,0,0,1,.46.46h0v1.72H130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.13,96.91h1.25a.47.47,0,0,1,.47.46h0v1.26a.47.47,0,0,1-.47.46h-1.72V96.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.48,
    y: 96.91,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.76,96.91a.46.46,0,0,0-.46.46v1.72h2.18V96.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.93,
    y: 96.91,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.21,99.09a.46.46,0,0,1-.46-.46v.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.56,
    y: 96.91,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.38,
    y: 96.91,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.2,
    y: 96.91,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.01,
    y: 96.91,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 96.91,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.65,98.63a.46.46,0,0,0,.46.46h1.72V96.91h-2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.03,
    y: 99.09,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.56,101.27a.46.46,0,0,0,.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.48,99.56v-.47h.46A.47.47,0,0,0,123.48,99.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.3,
    y: 99.09,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.21,99.09h1.26a.47.47,0,0,1,.46.47h0v1.25a.46.46,0,0,1-.46.46h-1.72V99.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.56,100.81a.46.46,0,0,0,.47.46h1.72V99.09h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.1,99.09h.46v.47a.46.46,0,0,0-.46-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.38,99.56v-.47h.46A.47.47,0,0,0,110.38,99.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.38,100.81a.46.46,0,0,1-.46.46h-1.26a.45.45,0,0,1-.46-.46V99.09h2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.73,99.09h.47v.47a.47.47,0,0,0-.47-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,99.56v-.47h.47A.47.47,0,0,0,106,99.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 99.09,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.37,99.09h.46v.47a.47.47,0,0,0-.46-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.74,99.09H99a.46.46,0,0,1,.46.47h0v1.25a.45.45,0,0,1-.46.46H97.28V99.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.56,99.09a.47.47,0,0,0-.46.47v1.71h2.18V99.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.03,
    y: 101.27,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.85,
    y: 101.27,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.38,103.46h-1.25a.47.47,0,0,1-.47-.47v-1.25a.47.47,0,0,1,.47-.47h1.72v2.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.3,
    y: 101.27,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.58,103.46a.47.47,0,0,1-.47-.47v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.83,103.46a.47.47,0,0,0,.47-.47v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.93,103v-1.25a.47.47,0,0,1,.46-.47h1.26a.47.47,0,0,1,.46.47h0v1.72h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.48,103.46A.47.47,0,0,1,106,103v.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 101.27,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.37,103.46a.47.47,0,0,0,.46-.47v.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 99.46,
    y: 101.27,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.28,101.74v-.47h.46A.47.47,0,0,0,97.28,101.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.28,103a.47.47,0,0,1-.46.47H95.56a.47.47,0,0,1-.46-.47v-1.72h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.03,
    y: 103.46,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.56,103.46H130v.46a.47.47,0,0,0-.47-.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.3,
    y: 103.46,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.11,
    y: 103.46,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.93,105.18a.47.47,0,0,0,.46.46h1.72v-2.18h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113,103.46h1.25a.47.47,0,0,1,.47.46h0v1.26a.47.47,0,0,1-.47.46h-1.72v-2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.38,
    y: 103.46,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.2,
    y: 103.46,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.01,
    y: 103.46,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.83,
    y: 103.46,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.37,105.64h-1.26a.46.46,0,0,1-.46-.46v-1.26a.46.46,0,0,1,.46-.46h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.93,105.64a.47.47,0,0,1-.47-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.28,105.18v-1.26a.47.47,0,0,1,.46-.46H99a.46.46,0,0,1,.46.46h0v1.72H97.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.82,105.64a.47.47,0,0,0,.46-.46v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.21,107.36a.46.46,0,0,1-.46.46h-1.26a.46.46,0,0,1-.46-.46v-1.72h2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.66,
    y: 105.64,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.48,107.36a.46.46,0,0,1-.47.46H121.3v-2.18h2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.11,107.36a.46.46,0,0,0,.47.46h1.72v-2.18h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M118.65,105.64h.46v.46a.47.47,0,0,0-.46-.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.75,
    y: 105.64,
    width: 2.18,
    height: 2.18,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.93,105.64h1.25a.47.47,0,0,1,.47.46h0v1.26a.46.46,0,0,1-.47.46H99.46v-2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 97.28,
    y: 105.64,
    width: 2.18,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.82,107.82H95.56a.46.46,0,0,1-.46-.46V106.1a.47.47,0,0,1,.46-.46h1.72v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.86,53.24a.47.47,0,0,0-.47.47V68.06a.47.47,0,0,0,.47.47h14.35a.47.47,0,0,0,.47-.47V53.71a.47.47,0,0,0-.47-.47Zm1.72,2.45a.26.26,0,0,1,.26-.26h10.39a.26.26,0,0,1,.26.26V66.08a.26.26,0,0,1-.26.26H136.84a.26.26,0,0,1-.26-.26V55.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.76,62V58.07a.47.47,0,0,1,.47-.46h5.62a.47.47,0,0,1,.46.46V63.7a.46.46,0,0,1-.46.46h-5.62a.46.46,0,0,1-.47-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.56,53.24a.46.46,0,0,0-.46.47V68.06a.46.46,0,0,0,.46.47h14.36a.47.47,0,0,0,.46-.47V53.71a.47.47,0,0,0-.46-.47Zm1.72,2.45a.27.27,0,0,1,.27-.26h10.38a.27.27,0,0,1,.27.26V66.08a.27.27,0,0,1-.27.26H97.55a.26.26,0,0,1-.27-.26V55.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.46,62V58.07a.47.47,0,0,1,.47-.46h5.62a.47.47,0,0,1,.47.46V63.7a.47.47,0,0,1-.47.46H99.93a.46.46,0,0,1-.47-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.86,92.54a.47.47,0,0,0-.47.46v14.36a.47.47,0,0,0,.47.47h14.35a.47.47,0,0,0,.47-.47V93a.47.47,0,0,0-.47-.46ZM136.58,95a.27.27,0,0,1,.26-.27h10.39a.27.27,0,0,1,.26.27v10.38a.26.26,0,0,1-.26.27H136.84a.27.27,0,0,1-.26-.27V95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.76,101.27v-3.9a.47.47,0,0,1,.47-.46h5.62a.46.46,0,0,1,.46.46V103a.46.46,0,0,1-.46.47h-5.62a.47.47,0,0,1-.47-.47Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(111.43 151.48)"
  }, "SCAN"), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M72.07,13.18V186a13.18,13.18,0,0,0,13.18,13.18h73A13.18,13.18,0,0,0,171.43,186V13.18A13.18,13.18,0,0,0,158.24,0h-73A13.18,13.18,0,0,0,72.07,13.18Zm4.59.92a9.6,9.6,0,0,1,9.6-9.6H98.33V6.92A6.69,6.69,0,0,0,105,13.61h34a6.69,6.69,0,0,0,6.69-6.69V4.5h11.52a9.6,9.6,0,0,1,9.6,9.6V42.53h0v114.1h0v28.43a9.6,9.6,0,0,1-9.6,9.61h-71a9.6,9.6,0,0,1-9.6-9.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.84,0h30.35a8.52,8.52,0,0,1,8.52,8.52v5.09a0,0,0,0,1,0,0H98.33a0,0,0,0,1,0,0V8.52A8.52,8.52,0,0,1,106.84,0Z",
    transform: "translate(244.04 13.61) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.9,8.72H115.81a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H134.9a1,1,0,0,1,1,1h0A1,1,0,0,1,134.9,8.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.27,7.85a1.15,1.15,0,1,0,1.14-1.15A1.14,1.14,0,0,0,109.27,7.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 76.66,
    y: 76.83,
    width: 90.18,
    height: 3.04,
    transform: "translate(243.5 156.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 76.66,
    y: 79.87,
    width: 90.18,
    height: 23.59,
    transform: "translate(243.5 183.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M166,226.26a15.94,15.94,0,0,1-2.23-6.2A9.12,9.12,0,0,1,166,226.26Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQrCode);
export default __webpack_public_path__ + "static/media/scan-qr-code.c624fadfc3b486b4e72fe2c2475e29d2.svg";
export { ForwardRef as ReactComponent };